export default "__VITE_ASSET__CZCHWTLA__"